// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.active-detail-dialog {
  display: flex;
  flex-direction: column;
  height: 100%;
  gap: 20px;
  min-height: 0;
}


/* Content Layout */
.active-detail-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 20px;
  overflow-y: auto;
  min-height: 0;
}

.active-info {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.active-header {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.active-name {
  margin: 0;
  color: var(--color-black);
  font-weight: 600;
}

.owned-tag {
  background-color: var(--surface-3);
  color: var(--text-primary);
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
}

/* Section Styling */
.effects-section,
.how-to-use-section,
.owned-products-section {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.section-label {
  color: var(--color-black);
  font-weight: 600;
  margin: 0;
}

.effects-text,
.owned-products-text {
  color: var(--color-dark-gray);
  margin: 0;
}

/* How to Use List */
.how-to-use-list {
  margin: 0;
  padding-left: 16px;
  color: var(--color-dark-gray);
}

.how-to-use-list li {
  margin-bottom: 4px;
}

.list-item {
  color: var(--color-dark-gray);
  margin: 0;
}

/* Experience Level Section */
.experience-level-section {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.level-chips {
  display: flex;
  gap: 8px;
}

.level-chip {
  flex: 1;
}


/* Loading and Error States */
.loading-state,
.error-state {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px 20px;
  text-align: center;
}

.error-state {
  color: var(--color-warning-red);
}

.error-text {
  color: var(--color-warning-red) !important;
}

/* Mobile Responsive */
@media (max-width: 768px) {
  .active-detail-dialog {
    gap: 16px;
  }
  
  .active-detail-header {
    padding-bottom: 12px;
  }
  
  
  .active-detail-content {
    gap: 16px;
  }
  
  .level-chips {
    flex-direction: column;
  }
}`, "",{"version":3,"sources":["webpack://./src/dialogs/ActiveDetailDialog.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,SAAS;EACT,aAAa;AACf;;;AAGA,mBAAmB;AACnB;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,0BAA0B;EAC1B,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;;;EAGE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,SAAS;AACX;;AAEA;;EAEE,6BAA6B;EAC7B,SAAS;AACX;;AAEA,oBAAoB;AACpB;EACE,SAAS;EACT,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,SAAS;AACX;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,OAAO;AACT;;;AAGA,6BAA6B;AAC7B;;EAEE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA,sBAAsB;AACtB;EACE;IACE,SAAS;EACX;;EAEA;IACE,oBAAoB;EACtB;;;EAGA;IACE,SAAS;EACX;;EAEA;IACE,sBAAsB;EACxB;AACF","sourcesContent":[".active-detail-dialog {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  gap: 20px;\n  min-height: 0;\n}\n\n\n/* Content Layout */\n.active-detail-content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  overflow-y: auto;\n  min-height: 0;\n}\n\n.active-info {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.active-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.active-name {\n  margin: 0;\n  color: var(--color-black);\n  font-weight: 600;\n}\n\n.owned-tag {\n  background-color: var(--surface-3);\n  color: var(--text-primary);\n  padding: 4px 8px;\n  border-radius: 12px;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n/* Section Styling */\n.effects-section,\n.how-to-use-section,\n.owned-products-section {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.section-label {\n  color: var(--color-black);\n  font-weight: 600;\n  margin: 0;\n}\n\n.effects-text,\n.owned-products-text {\n  color: var(--color-dark-gray);\n  margin: 0;\n}\n\n/* How to Use List */\n.how-to-use-list {\n  margin: 0;\n  padding-left: 16px;\n  color: var(--color-dark-gray);\n}\n\n.how-to-use-list li {\n  margin-bottom: 4px;\n}\n\n.list-item {\n  color: var(--color-dark-gray);\n  margin: 0;\n}\n\n/* Experience Level Section */\n.experience-level-section {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.level-chips {\n  display: flex;\n  gap: 8px;\n}\n\n.level-chip {\n  flex: 1;\n}\n\n\n/* Loading and Error States */\n.loading-state,\n.error-state {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 40px 20px;\n  text-align: center;\n}\n\n.error-state {\n  color: var(--color-warning-red);\n}\n\n.error-text {\n  color: var(--color-warning-red) !important;\n}\n\n/* Mobile Responsive */\n@media (max-width: 768px) {\n  .active-detail-dialog {\n    gap: 16px;\n  }\n  \n  .active-detail-header {\n    padding-bottom: 12px;\n  }\n  \n  \n  .active-detail-content {\n    gap: 16px;\n  }\n  \n  .level-chips {\n    flex-direction: column;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
